import { render, staticRenderFns } from "./service_provider.vue?vue&type=template&id=88da7e30&scoped=true&"
import script from "./service_provider.vue?vue&type=script&lang=js&"
export * from "./service_provider.vue?vue&type=script&lang=js&"
import style0 from "./service_provider.vue?vue&type=style&index=0&id=88da7e30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88da7e30",
  null
  
)

export default component.exports